<template>
  <section
    class="page-banner"
    :style="{ backgroundImage: `url(${backgroundImage || defaultImage})` }"
  >
    <div class="banner-overlay"></div>
    <div class="banner-content">
      <h1 class="animate-up">{{ title }}</h1>
      <p class="animate-up delay-1">{{ subtitle }}</p>
    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
  backgroundImage: {
    type: String,
    default: '',
  },
});

// Fallback image if none is provided
const defaultImage =
  'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?q=80&w=1600';
</script>

<style scoped>
.page-banner {
  position: relative;
  height: 350px;
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}

.banner-content {
  position: relative;
  z-index: 1;
  padding: 0 20px;
}

.banner-content h1 {
  font-size: 3.5rem;
  margin-bottom: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: -1px;
}

.banner-content p {
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto;
  opacity: 0.9;
}

.animate-up {
  animation: fadeInUp 0.8s ease forwards;
}

@media (max-width: 768px) {
  .page-banner {
    height: 300px;
  }
  .banner-content h1 {
    font-size: 2.5rem;
  }
  .banner-content p {
    font-size: 1rem;
  }
}
</style>
